import {
    WEBCHAT,
} from 'Constant';

/**
 * NAMESPACE
 */
 export const NAMESPACE = 'UI';

/**
 * SET_DEFAULT_STATE
 */
export const SET_DEFAULT_STATE = `${WEBCHAT}/${NAMESPACE}/SET_DEFAULT_STATE`;

/**
 * MESSAGE_HAS_SENT
 */
export const MESSAGE_HAS_SENT = `${WEBCHAT}/${NAMESPACE}/MESSAGE_HAS_SENT`;

/**
 * Container Webchat ID where ChatHeader is rendered into
 */
export const ID_WEBCHAT_HEADER = `${WEBCHAT}-header`;

/**
 * Container Webchat ID where Chat is rendered into
 */
export const ID_WEBCHAT_OUTPUT = `${WEBCHAT}-output`;

/**
 * Container for Webchat Input Panel
 */
export const ID_WEBCHAT_INPUT_PANEL = `${WEBCHAT}-input-panel`;

/**
 * Container for Webchat Input Panel
 */
export const BRIX_OPTIONPICKER_IMG_CLASSNAME = `brix-option-picker__img`;

/**
 * Const ICON_ASSISTENT
 */
export const CLASSNAME_WEBCHAT_TRIGGER = `${WEBCHAT}-trigger`;

/**
 * Const Container loading
 */
 export const CONTAINER_LOADING_ANINMATION = `${WEBCHAT}-loading-animation`;

/**
 * Const WRAPPER_GROUP
 */

export const WRAPPER_GROUP_NAME = 'wrapper_group';
/**
 * Const WRAPPER_OPTION_NAME
 */
export const WRAPPER_OPTION_NAME = 'wrapper_options';

/**
 * Const WRAPPER_CHATBUBBLES_NAME
 */
export const WRAPPER_CHATBUBBLES_NAME = 'wrapper_chatbubbles';

/**
 * Const WRAPPER_BUTTON_NAME
 */
export const WRAPPER_BUTTON_NAME = 'wrapper_buttons';

/**
 * Const WRAPPER_ICON_TEXT_NAME
 */
export const WRAPPER_ICON_TEXT_NAME = 'wrapper_icon_text';

/**
 * Const Indicator Response from Agent
 */
export const RESPONSE_TYPE_FROM_AGENT = 'Agent';

/**
 * Const Indicator Response Participent joined
 */
 export const RESPONSE_TYPE_PARTICIPENT_JOINDED = 'ParticipantJoined';

/**
 * Const Indicator Response Type Message
 */
 export const RESPONSE_TYPE_MESSAGE = 'Message';

/**
 * Const Wakeup_Ping
 */
export const WAKEUP_PING = 'hello';

/**
 * Container body Webchat ID where Chat is rendered into
 */
 export const ID_WEBCHAT_BODY = `${WEBCHAT}-container__body`;
/**
 * Const OPEN
 */
export const OPEN = '1';
/**
 * Const PATH
 */
export const PATH = 'data-wc-path';
/**
 * Const TOPIC
 */
export const TOPIC = 'data-wc-topic';
/**
 * Const BOTNAME
 */
export const BOTNAME = 'data-wc-botname';
/**
 * Const HEADLINE
 */
export const HEADLINE = 'TOBi';
/**
 * Const SUBLINE
 */
export const SUBLINE = 'Dein Digitaler Assistent';
/**
 * Const IMGICONSRC
 */
export const IMGICONSRC = '/media/img/icons/mid-render/tobi-chat-header.svg';
/**
 * Const WEBCHAT_START_ANCHOR
 */
export const WEBCHAT_START_ANCHOR = 'webchat-start-anchor';
/**
 * Const OPEN_KEY_PARAM
 */
export const OPEN_KEY_PARAM = 'open';
/**
 * Const MARKET_KEY_PARAM
 */
export const MARKET_KEY_PARAM = 'market';
/**
 * Const INTENT_KEY_PARAM
 */
export const INTENT_KEY_PARAM = 'intent';
